var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1018.5 -613.5)",
    clipPath: "url(#download_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049 648h-21a4 4 0 01-4-4v-6a1 1 0 012 0v6a2 2 0 002 2h21a2 2 0 002-2v-6a1 1 0 012 0v6a4 4 0 01-4 4z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    className: "download_svg__arrow",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1038.5 639a1 1 0 01-.707-.293l-7.5-7.5a1 1 0 011.414-1.414l6.793 6.793 6.793-6.793a1 1 0 111.414 1.414l-7.5 7.5a1 1 0 01-.707.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.5 639a1 1 0 01-1-1v-18a1 1 0 012 0v18a1 1 0 01-1 1z"
  })))));
}
export default SvgDownload;